import React from "react";
import apiClient from "../../clients/apiClient.js";
import { Box, Button, Flex, HStack, IconButton, Input, InputGroup, InputLeftElement, Modal, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import SearchIcon from "@mui/icons-material/Search";
import WeblinkModal from "./WeblinkModal";

const WeblinkLibrary = ({ onOpen, isLibraryOpen, onClose }) => {
    const [loading, setLoading] = React.useState(false);
    const [weblinks, setWeblinks] = React.useState(null);
    const [searchQuery, setSearchQuery] = React.useState(''); // State for search query
    const [maxWeblinks, setMaxWeblinks] = React.useState(0);
  
    const getLibraryWeblinks = () => {
      setLoading(true);
  
      apiClient
        .get('/library/weblinks')
        .then((response) => {
          if (response.data.links === null) {
            setWeblinks([]);
          } else {
            setWeblinks(response.data.links); // Access the response data
          }
          if (response.data.limit != null) {
            setMaxWeblinks(response.data.limit?.max_links)
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Error fetching weblinks:', error);
          setLoading(false); // Handle errors and stop loading
        });
    };
  
    React.useEffect(() => {
      getLibraryWeblinks();
    }, []);
  
    const filteredWeblinks = weblinks?.filter((weblink) =>
      (
        weblink.link_url?.toLowerCase().includes(searchQuery.toLowerCase())
      ) || (
        weblink.name?.toLowerCase().includes(searchQuery.toLowerCase())
      ) || (
        weblink.description?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  
    const refreshWeblink = ({generated_link_id}) => {
      console.log("[WeblinkLibrary] refreshWeblink 2", generated_link_id)
      let refreshWeblink = {
        generated_link_id: generated_link_id,
      }
  
      apiClient
        .post('/library/weblinks', { 
          action: "refresh_link",
          refresh_link: refreshWeblink,
         })
        .then((response) => {
          window.location.reload()
        })
    }
  
  
  
    const getTimeDifference = (timeString) => {
      const time = new Date(timeString);
      const now = new Date();
      const diff = now - time;
  
      const minutes = Math.floor(diff / 60000);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
  
      if (days > 0) {
        if (days === 1) {
          return `${days} day ago`;
        }
        return `${days} days ago`;
      } else if (hours > 0) {
        if (hours === 1) {
          return `${hours} hour ago`;
        }
        return `${hours} hours ago`;
      } else if (minutes > 0) {
        if (minutes === 1) {
          return `${minutes} minute ago`;
        }
        return `${minutes} minutes ago`;
      } else {
        return `just now`;
      }
    };
  
  
    const isRefreshIntervalExceeded = (lastRefreshedAt, refreshInterval) => {
      const time = new Date(lastRefreshedAt);
      const now = new Date();
      const diff = now - time;
  
      const [minutes, seconds] = refreshInterval.split('m').map((val) => parseInt(val, 10));
      const intervalInMilliseconds = (minutes * 60 + seconds) * 1000;
  
      return diff > intervalInMilliseconds;
    };
  
    if (loading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="50%"
            >
                <Text fontSize="2xl" fontWeight="bold">Loading...</Text>
            </Box>
        )
    }
    
    return (
      <Box width={"100wh"} maxWidth={"100wh"}>
        {/* Filters */}
        <Flex mb={6} align="center" gap={4}>
          <InputGroup maxW="300px">
            <InputLeftElement pointerEvents="none">
              <IconButton style={{ color: 'grey', backgroundColor: "transparent" }} ><SearchIcon/></IconButton>
            </InputLeftElement>
            <Input
              placeholder="Search a link"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            />
          </InputGroup>
          <HStack flex="1" display="flex" justifyContent="flex-end">
            <Text>
                {weblinks?.length || 0} / {maxWeblinks} Weblinks
            </Text>
            <Button onClick={onOpen}
              backgroundColor={"#2584FD"}
              color={"white"}
              marginRight={"8px"}
              _hover={{
                backgroundColor: "#2584FD",
                color: "white",
              }}
            > Add Web Link </Button>
          </HStack>
        </Flex>
  
          <TableContainer
            bg="white"
            shadow="md"
            borderRadius="md"
            height="calc(100vh - 300px)"
            width={"100%"}
            maxWidth={"100%"}
            overflowY="auto"
            overflowX="auto"
          >
            <Table variant="simple" maxW={"100%"}>
              <Thead position="sticky" top={0} zIndex={1} bg="white" maxW={"100%"}>
                <Tr maxW={"10px"}>
                  <Th rightPadding={0} maxWidth="25%">Name</Th>
                  <Th maxWidth="25%">Url</Th>
                  <Th maxWidth="30%">Description</Th>
                  <Th>Last Refreshed At</Th>
                </Tr>
              </Thead>
              <Tbody maxW={"10%"}>
            {filteredWeblinks?.map((weblink) => {
              const {
                generated_link_id,
                link_url,
                name,
                description = '',
                last_refreshed_at,
              } = weblink;
              console.log("[WeblinkLibrary] weblink", generated_link_id)
              return (
                <Tr key={generated_link_id} alignItems="center" maxW={"100%"}>
                <Td>
                  <Text>{name || '-'}</Text>
                </Td>
                <Td rightPadding={0} py={2} px={3}>
                  <a 
                  href={link_url} 
                  target='_blank' 
                  rel='noreferrer' 
                  style={{ color: '#2584FD', textDecoration: 'none' }}
                  onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseOut={(e) => e.target.style.textDecoration = 'none'}
                  >
                  {link_url}
                  </a>
                </Td>
                <Td maxWidth="100%" whiteSpace="normal" wordBreak="break-word">
                  <Text>
                  {description}
                  </Text>
                </Td>
                {isRefreshIntervalExceeded(last_refreshed_at, "5m0s") ?
                  <Td 
                  onClick={() => refreshWeblink({generated_link_id})}
                  style={{ textDecoration: 'underline dotted' }}
                  _hover={{ cursor: 'pointer' }}
                  title="Click to re-scrape data from the link"
                  >
                  {getTimeDifference(last_refreshed_at)}
                  </Td>
                  : 
                  <Td>
                  {getTimeDifference(last_refreshed_at)}
                  </Td>
                }
                </Tr>
              );
  
            })}
              </Tbody>
            </Table>
          </TableContainer>
  
          <Modal
            isOpen={isLibraryOpen}
          // placement="right"
          size="lg"
          onClose={() => {
            getLibraryWeblinks();
            onClose();
            window.location.reload(); // Reload the page
          }}
        >
          <WeblinkModal
            setIsLibraryOpen={() => {
              getLibraryWeblinks();
              onClose();
              window.location.reload(); // Reload the page
            }}
          />
        </Modal>
      </Box>
    )
  }

export default WeblinkLibrary;